import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-76">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-77" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none p-4" data-id="element-78">
            <div className="bg-[#141414] border border-gray-800 w-full max-w-2xl max-h-[80vh] rounded-lg shadow-2xl pointer-events-auto flex flex-col overflow-hidden" data-id="element-79">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-800 bg-[#141414]" data-id="element-80">
                <h3 className="text-xl font-bold text-white font-display" data-id="element-81">
                  {title}
                </h3>
                <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-1 rounded-md hover:bg-gray-800" aria-label="Cerrar" data-id="element-82">
                  <XIcon className="w-6 h-6" data-id="element-83" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto custom-scrollbar text-gray-300 leading-relaxed space-y-4" data-id="element-84">
                {children}
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}